import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Parameter } from '../models/parameter';
import { PictureService } from './picture.service';

@Injectable()
export class ParameterService {

  private parameter: Parameter;
  private logo: string;
  private smallLogo: string;

  constructor(private http: HttpClient, private pictureService: PictureService) { }

  getTheme(): string {
    if (this.parameter) {
      if (this.parameter.ShortName) {
        return this.parameter.ShortName;
      } else {
        return 'vendere';
      }
    } else {
      return 'vendere';
    }
  }

  getFullBrandLogo(): string {
    if (this.logo) {
      return this.logo;
    } else {
      return null;
    }
  }

  getSmallBrandLogo(): string {
    if (this.smallLogo) {
      return this.smallLogo;
    } else {
      return null;
    }
  }

  public getOrgEmail(): string {
    if (this.parameter) {
      if (this.parameter.Email) {
        return 'mailto:' + this.parameter.Email;
      } else {
        return 'mailto:info@locali-t.com';
      }
    } else {
      return 'mailto:info@locali-t.com';
    }
  }

  setParameter(parameter: Parameter) {
    this.parameter = parameter;
    if (parameter) {
      this.logo = parameter.FullBrandingPictureUrl;
      this.smallLogo = parameter.SmallBrandingPictureUrl;
    }
  }

  getParameter(): Parameter {
    return this.parameter;
  }

  getParameterAPI(chamberID: string): Promise<any> {
    return this.http.get<any>(environment.apiURL + 'parameter?chamberid=' + chamberID)
    .toPromise()
    .then((result) => result)
    .catch((error) => error);
  }

  getChapterAPI(chamberID: string): Promise<any> {
    return this.http.get<any>(environment.apiURL + 'chapter?orgid=' + chamberID)
    .toPromise()
    .then((result) => result)
    .catch((error) => error);
  }

  getPing(): Promise<any> {
    return this.http.get<any>(environment.apiURL + 'identity/ping')
    .toPromise()
    .then(result => result)
    .catch(error => error);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/services/parameter.service.ts